import React, { useEffect, useState } from "react";
import "../component/style.css";
import SideNav from "../component/sideNav";
import Header from "../component/header";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { ProjectApi, UserApi } from "../apis";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import InsightsIcon from "@mui/icons-material/Insights";
import EditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { projectInfo, resetRoofInfo } from "../Features/roofInfo";
import {
  resetQuantityInfo,
  updateQuantityInfo,
} from "../Features/quantityInfo";
import { resetReportInfo, setReportInfo } from "../reducer/reportInfo.reducer";
import { resetInverterInfo } from "../Features/inverterInformation";
import { projectCapacity } from "../Components/Dashboard/componentDashboard/mainComponents/projectFunction";
import InfoGraphics from "../Components/Dashboard/componentDashboard/mainComponents/infographics";
import Stats from "../Components/Dashboard/componentDashboard/mainComponents/stats";
import { updateStatusInfo } from "../Features/statusInfo";

const Projects = () => {
  const dispatch = useDispatch();
  const conUser = useSelector((state) => state?.conUser);
  const [Projects, setProjects] = useState([]);
  const [paginator, setPaginator] = useState({
    page: 0,
    perPage: 10,
  });

  const [totalCount, setTotalCount] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState({});
  const ProjectsRouter = ProjectApi();
  const DesignerRouter = UserApi();
  const navigate = useNavigate();

  //filter Attributes
  const [designerData, setDesignerData] = useState([]);
  const [sortFltr, setSortFltr] = useState("ALL");
  const [designerID, setDesignerID] = useState("");
  const [statusFltr, setStatusFltr] = useState("");

  // Attributes
  const [displayDeleteModal, setDisplayDeleteModal] = useState(false);

  const toggleDeleteModal = () => setDisplayDeleteModal(!displayDeleteModal);

  const columns = [
    {
      field: "siteName",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Site Name
        </div>
      ),
      flex: 1,
      renderCell: (row) => row?.siteName,
      sortable: false,
    },
    {
      field: "capacity",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Capacity
        </div>
      ),
      flex: 1,
      renderCell: ({ row }) => projectCapacity(row),
      sortable: false,
    },
    {
      field: "siteAddress",
      headerName: (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            minWidth: "300px",
          }}
        >
          Site Address
        </div>
      ),
      flex: 1,
      renderCell: (row) => row?.siteAddress,
      sortable: false,
    },
    {
      field: "date",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Installation Date
        </div>
      ),
      flex: 1,
      renderCell: (params) => {
        const dateString = params.row?.date;
        if (!dateString) return "";
        const dateObject = new Date(dateString);
        const formattedDate = dateObject.toISOString().split("T")[0];

        return formattedDate;
      },
      sortable: false,
    },
    {
      field: "customerName",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Customer
        </div>
      ),
      flex: 1,
      renderCell: (row) => row?.customerName,
      sortable: false,
    },
    {
      field: "status",
      headerName: (
        <div
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          Status
        </div>
      ),
      flex: 1,
      renderCell: (params) => {
        const str = params.row?.status;
        const val = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        return val;
      },
      sortable: false,
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      getActions: ({ row }) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Detail" placement="top">
              <InsightsIcon style={{ color: "green", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Detail"
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Edit" placement="top">
              <EditIcon style={{ color: "#27326A", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Edit"
          onClick={() => {
            setSelectedRecord(row);
            editProjects(row);
          }}
        />,
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete" placement="top">
              <DeleteIcon style={{ color: "red", width: 24, height: 24 }} />
            </Tooltip>
          }
          label="Delete"
          onClick={() => {
            toggleDeleteModal();
            setSelectedRecord(row?._id);
          }}
        />,
      ],
    },
  ];

  useEffect(() => {
    getAllProjects({ sort: conUser?.roles[0]  === "ADMIN" ? "ALL" : "SELF" });
    setSortFltr(conUser?.roles[0]  === "ADMIN" ? "ALL" : "SELF");
    // eslint-disable-next-line
  }, [paginator]);

  useEffect(() => {
    getAllDesigners();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getStats({ sort: conUser?.roles[0] === "ADMIN" ? "ALL" : "SELF" });
    //eslint-disable-next-line
  }, []);

  const getStats = async ({
    sort = "ALL",
    designerId = "",
    status = "",
  } = {}) => {
    try {
      const res = await ProjectsRouter.getStats({
        sort: sort,
        designerId: designerId,
        status: status,
      });
      if (res?.data) {
        const stats = res?.data?.data;
        dispatch(updateStatusInfo({ ...stats }));
      }
    } catch (error) {
      console.log("Projects ", error);
    }
  };

  const getAllProjects = async ({
    sort = "ALL",
    designerId = "",
    status = "",
  } = {}) => {
    try {
      const res = await ProjectsRouter.getAll({
        page: paginator.page,
        pageSize: paginator.pageSize,
        sort: sort ? sort : "ALL",
        designerId: sort === "DESIGNER" ? designerId : "",
        status: status,
      });
      if (res?.data) {
        setProjects(res?.data);
        setTotalCount(res?.pagination?.totalCount);
      }
    } catch (error) {
      console.log("Projects ", error);
    }
  };

  const getAllDesigners = async () => {
    try {
      const res = await DesignerRouter.getDesigner();
      if (res?.data) {
        setDesignerData(res?.data);
      }
    } catch (error) {
      console.log("Designers ", error);
    }
  };

  const removeProjects = async (id) => {
    try {
      const res = await ProjectsRouter.remove(id);
      if (res) {
        toggleDeleteModal();
        getAllProjects();
      }
    } catch (error) {
      console.log("Projects ", error);
    }
  };

  const editProjects = async (row) => {
    sessionStorage.setItem("projectId", row._id);
    dispatch(projectInfo({ value: row.value }));
    dispatch(updateQuantityInfo(row.quantityInfo));
    if (row?.disclaimerInfo) {
      dispatch(
        setReportInfo({
          companyName: row?.companyName,
          companyLogo: row?.companyLogo,
          disclaimerTermsCondition:
            row?.disclaimerInfo?.disclaimerTermsCondition,
          companyAddress: row?.disclaimerInfo?.companyAddress,
          companyPhoneNo: row?.disclaimerInfo?.companyPhoneNo,
          companyEmail: row?.disclaimerInfo?.companyEmail,
        })
      );
    }
    navigate("/createProject");
  };

  const createProject = () => {
    const RemoveItem = [
      "projects",
      "cid",
      "customerName",
      "projectId",
      "roofPolygons",
      "structureItem",
      "myData",
      "imageSrc",
    ];
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    dispatch(resetRoofInfo());
    dispatch(resetInverterInfo());
    dispatch(resetQuantityInfo());
    dispatch(resetReportInfo());
    navigate("/createProject");
  };

  const handleSelectDesigner = (e) => {
    const designerId = e.target.value;
    const filters = {
      sort: "DESIGNER",
      designerId: designerId,
      status: statusFltr,
    };
    setDesignerID(designerId);
    setSortFltr("DESIGNER");
    getAllProjects(filters);
    getStats(filters);
  };

  const handleSortOption = (e) => {
    const val = e.target.value;
    setSortFltr(val);
    const filters = { status: statusFltr };
    if (val === "SELF") {
      filters.sort = val;
    }
    getAllProjects(filters);
    getStats(filters);
  };

  const handleStatus = (e) => {
    const val = e.target.value;
    setStatusFltr(val);
    const filters = { sort: sortFltr, designerId: designerID, status: val };
    getAllProjects(filters);
    getStats(filters);
  };

  const statusOption = ["Complete", "Pending", "InProgress", "Draft"];
  const sortOption = ["ALL", "SELF", "DESIGNER"];

  return (
    <>
      <div className="mainContainer">
        {/* Delete Dialog */}
        <Dialog open={displayDeleteModal} onClose={toggleDeleteModal}>
          <DialogTitle>DELETE PROJECT</DialogTitle>
          <DialogContent>
            Are you sure you want to delete this project?
            <h3 className="infoAlert">
              *All details will be lost and can not be recovered
            </h3>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={toggleDeleteModal}
              variant="contained"
              sx={{ backgroundColor: "#27326A" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => removeProjects(selectedRecord)}
              variant="contained"
              sx={{ backgroundColor: "#FF7C1B" }}
            >
              Delete Project
            </Button>
          </DialogActions>
        </Dialog>

        <Header></Header>
        <SideNav active="Dashboard" />
        <div className="contentBox">
          <InfoGraphics />
          <Stats />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1%",
              gap: "10px",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              {conUser?.roles[0] === "ADMIN" && (
                <Select
                  id="select"
                  value={sortFltr}
                  onChange={handleSortOption}
                  variant="outlined"
                  displayEmpty
                  sx={{ width: 150 }}
                  renderValue={(selected) =>
                    selected ? selected : "Select Sort"
                  }
                >
                  <MenuItem value="">Select Sort</MenuItem>
                  {sortOption.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              )}
              {sortFltr === "DESIGNER" && (
                <Select
                  id="select"
                  onChange={handleSelectDesigner}
                  variant="outlined"
                  displayEmpty
                  sx={{ width: 150 }}
                  renderValue={(selected) =>
                    selected
                      ? designerData.find((d) => d._id === selected)?.name
                      : "Select Designer"
                  }
                >
                  <MenuItem value="">Select Designer</MenuItem>
                  {designerData?.map((d) => (
                    <MenuItem key={d._id} value={d._id}>
                      {d.name}
                    </MenuItem>
                  ))}
                </Select>
              )}

              <Select
                id="select"
                value={statusFltr}
                onChange={handleStatus}
                variant="outlined"
                displayEmpty
                sx={{ width: 150 }}
                renderValue={(selected) =>
                  selected ? selected : "select status"
                }
              >
                <MenuItem value="">select status</MenuItem>
                {statusOption.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <TextField
                label="Search"
                margin="dense"
                variant="outlined"
                id="outlined-start-adornment"
                sx={{ m: 1, width: "25ch" }}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon></SearchIcon>
                      </InputAdornment>
                    ),
                  },
                }}
              />
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: "#27326A",
                  width: "148px",
                  height: "40px",
                  textTransform: "none",
                }}
                onClick={() => createProject()}
              >
                <AddCircleOutlineIcon
                  sx={{ marginRight: "10px", width: 18, height: 18 }}
                />
                Create Projects
              </Button>
            </Grid>
          </Box>

          {/* tables display */}
          <DataGrid
            sx={{
              borderRadius: 3,
              border: 0,
              width: "100%",
              outline: "none", // Remove blue outline
              overflow: "visible",
              ".MuiDataGrid-main": {
                overflow: "visible",
              },
              ".MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold !important",
                overflow: "visible !important",
                color: "#27326A",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-sortIcon": {
                display: "none !important",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                {
                  outline: "none", // Remove blue outline
                },
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none", // Remove blue outline
              },
              "& .MuiDataGrid-cell": {
                outline: "none", // Remove blue outline from cells
              },
              "& .MuiDataGrid-cell--textLeft": {
                textAlign: "left",
              },
              "& .MuiDataGrid-cell--textCenter": {
                textAlign: "center",
              },
              "& .MuiDataGrid-cell--textRight": {
                textAlign: "right",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "transparent !important",
              },
              "& .MuiDataGrid-row:nth-of-type(even)": {
                backgroundColor: "white",
                boxShadow: "0px 0px 30px #EDEEF4",
                outline: "none",
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                outline: "none",
              },
              "& .name-cell-style": {
                color: "#566477",
                outline: "none",
              },
              "& .default-cell-style": {
                color: "#95A2B4",
                outline: "none",
              },
              "& .MuiDataGrid-row": {
                borderBottom: "none",
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {},
            }}
            disableColumnMenu
            disableSelectionOnClick
            getRowId={(row) => row._id}
            columns={columns}
            rows={Projects}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterExcludeHiddenColumns: true,
                },
              },
              pagination: {
                paginationModel: { page: 0, pageSize: paginator.perPage },
              },
            }}
            paginationMode="server"
            rowCount={totalCount}
            onPaginationModelChange={(newPage) => {
              setPaginator({
                page: newPage?.page,
                perPage: newPage?.pageSize,
              });
            }}
            pageSizeOptions={[10]}
          ></DataGrid>
        </div>
      </div>
    </>
  );
};

export default Projects;
